import React from 'react';
import { observer } from 'mobx-react';
import OptionCard from './OptionCard';
import SelectCustom from "../../../common/components/input/SelectCustom"

import CloseIcon from '@material-ui/icons/Close';
import { IconButton, CircularProgress } from '@material-ui/core';

function SharedUser({ data, roles, onDelete, onUpdate, isSaving }) {
    const adminUserRole = { id: "admin_user", name: "Admin User" };
    const currentRoles = data.is_owner && !data.role_id ? [adminUserRole] : [...roles];
    const value = data.is_owner && !data.role_id ? adminUserRole : currentRoles.find(item => item.id == data.role_id);

    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between"
        }}>
            <OptionCard data={data} />
            <div style={{
                display: "flex",
                alignItems: "center"
            }}>
                <SelectCustom
                    values={currentRoles}
                    disabled={data.is_owner || isSaving || false}
                    valueKey={"id"}
                    style={{
                        marginLeft: 10
                    }}
                    value={value}
                    onChange={(val) => {
                        onUpdate(data, val);
                    }}
                    shouldForwardEvent={false}
                />
                {
                    !isSaving ?
                        <IconButton
                            style={{
                                visibility: !data.is_owner ? "visible" : "hidden",
                            }}
                            onClick={() => onDelete(data)}>
                            <CloseIcon style={{
                                fontSize: 12,
                            }} />
                        </IconButton>
                        :
                        <div style={{ width: 40, paddingLeft: 5 }}>
                            <CircularProgress size={20} />
                        </div>
                }
            </div>
        </div>
    );
}


export default observer(SharedUser);